import { z } from "zod";

export const ProfileFieldValueSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
export const ProfileFieldSchema = z.object({
  id: z.string(),
  label: z.string(),
  description: z.string(),
  kind: z.enum(["text", "number", "date", "select", "boolean"]),
  visibility: z.enum(["private", "management", "public"]),
  required: z.boolean(),
  active: z.boolean(),
  position: z.number().int(),
  options: z.array(z.string()),
});
export const ProfileFieldAnswerSchema = ProfileFieldSchema.extend({
  value: ProfileFieldValueSchema,
});
export type ProfileField = z.infer<typeof ProfileFieldSchema>;
export type ProfileFieldAnswer = z.infer<typeof ProfileFieldAnswerSchema>;
export type ProfileFieldInput = Omit<ProfileField, "id">;
export type ProfileFieldValue = z.infer<typeof ProfileFieldValueSchema>;
export const FIELD_KINDS = {
  text: "Texto",
  number: "Número",
  date: "Data",
  select: "Seleção",
  boolean: "Sim ou não",
} as const;
export const FIELD_VISIBILITY = {
  private: "Membro e gestão",
  management: "Somente gestão",
  public: "Perfil público",
} as const;
